export enum PropTradingStatusType {

    New = 1,
    Active = 2,
    Failed = 3,
    WDUnlocked = 4,
    Success = 5
}